import '@brainhubeu/react-carousel/lib/style.css';

import React, { useState } from 'react';

import Carousel from '@brainhubeu/react-carousel';
import { css } from '@emotion/core';
import { Box, Button } from '@rebass/emotion';
import Colors from '@theme/colors';

interface SlideshowProps {
  children: any;
}

const handleCarouselItemClick = (value: number, setValue: (value: number) => void) => {
  setValue(value);
};

const getCurrentSelect = (currentValue: number, carouselItem: number) => {
  return currentValue === carouselItem ? Colors.science37 : Colors.gray;
};

function Slideshow({ children }: SlideshowProps) {
  // Declare a new state variable, which we'll call "count"
  const [value, setValue] = useState();
  return (
    <>
      <Carousel value={value} onChange={(val: number) => handleCarouselItemClick(val, setValue)}>
        {children}
      </Carousel>
      <Box
        mt={-80}
        css={css`
          text-align: right;
          button {
            height: 4px;
            width: 30px;
            margin-right: 4px;
            padding: 0;
            :focus {
              outline: none !important;
            }
            cursor: pointer;
          }
          position: absolute;
          right: 30px;
        `}
      >
        {children.map((val: object, i: number) => (
          <Button
            key={`caption-${i}`}
            type="button"
            onClick={() => handleCarouselItemClick(i, setValue)}
            bg={getCurrentSelect(value, i)}
          />
        ))}
      </Box>
    </>
  );
}

export default Slideshow;
